import { LalSegmentFields, segmentRowActionType } from '@openx/types/segments';
import type { I18nTranslate } from '@openx/types/translations';
import type { SectionLabels } from './types';

export const expiringSoonStatus = 'expiring_soon';

export const getActionLabels = (t: I18nTranslate) => ({
  [segmentRowActionType.DELETE]: t('Archive'),
  [segmentRowActionType.RENAME]: t('Rename'),
});

export const getLalSegmentLabels = (t: I18nTranslate) => ({
  [LalSegmentFields.NAME]: t('Lookalike Segment Name'),
  [LalSegmentFields.ACCOUNT_ID]: t('Account'),
  [LalSegmentFields.PROVIDER]: t('Provider'),
  [LalSegmentFields.SEED_NAME]: t('Seed Segment Name'),
});

export const getSectionLabels = (t: I18nTranslate): SectionLabels => ({
  source_matched_count: t('Source IDs matched'),
  source_provided_count: t('Source IDs provided'),
  cookie_provided: t('Cookies provided'),
  cookie_matched: t('Cookies matched'),
  device_provided: t('Mobile Devices provided'),
  device_matched: t('Mobile Devices matched'),
  id5_provided: t('ID5 provided'),
  id5_matched: t('ID5 matched'),
  ip_provided: t('IP Addresses provided'),
  ip_matched: t('IP Addresses matched'),
  idl_provided: t('RampIDs provided'),
  idl_matched: t('RampIDs matched'),
  analyticsiq_provided: t('AnalyticsIQ provided'),
  analyticsiq_matched: t('AnalyticsIQ matched'),
  azerion_provided: t('Azerion provided'),
  azerion_matched: t('Azerion matched'),
  bombora_provided: t('Bombora provided'),
  bombora_matched: t('Bombora matched'),
  catalist_provided: t('Catalist provided'),
  catalist_matched: t('Catalist matched'),
  contanuity_provided: t('Contanuity provided'),
  contanuity_matched: t('Contanuity matched'),
  fantix_provided: t('Fantix provided'),
  fantix_matched: t('Fantix matched'),
  growthcode_provided: t('GrowthCode provided'),
  growthcode_matched: t('GrowthCode matched'),
  healthlink_provided: t('HealthLink provided'),
  healthlink_matched: t('HealthLink matched'),
  horizon_provided: t('Horizon provided'),
  horizon_matched: t('Horizon matched'),
  iqvia_provided: t('IQVIA provided'),
  iqvia_matched: t('IQVIA matched'),
  klover_provided: t('Klover provided'),
  klover_matched: t('Klover matched'),
  liveintent_provided: t('LiveIntent provided'),
  liveintent_matched: t('LiveIntent matched'),
  merkle_provided: t('Merkle provided'),
  merkle_matched: t('Merkle matched'),
  phone_provided: t('Phone Numbers provided'),
  phone_matched: t('Phone Numbers matched'),
  rtbhouse_provided: t('RTBHouse provided'),
  rtbhouse_matched: t('RTBHouse matched'),
  choreograph_matched: t('Choreograph matched'),
  choreograph_provided: t('Choreograph provided'),
  epsilon_matched: t('Epsilon matched'),
  epsilon_provided: t('Epsilon provided'),
  email_matched: t('Email matched'),
  email_provided: t('Email provided'),
  wrango_matched: t('Wrango matched'),
  wrango_provided: t('Wrango provided'),
});

export const MIN_AUC_SCORE_THRESHOLD = 0.65;
